import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { AgentRegister } from '../../../models/agents/agent-register';
import { RegistrationService } from '../../../services/registration.service';
import { AuthState } from '../../../state-manager/state/auth.state';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../../services/loading.service';

@Component({
  selector: 'app-register-middleware',
  templateUrl: './register-middleware.component.html',
  styleUrls: ['./register-middleware.component.scss']
})
export class RegisterMiddlewareComponent implements OnInit, OnDestroy {
  isExternal = false;
  isInternal = false;
  invitationId$: string;
  agent$: AgentRegister;
  subscription: Subscription;

  constructor(
    protected registrationService: RegistrationService,
    protected store: Store,
    private route: ActivatedRoute,
    protected loadingService: LoadingService
  ) {
    this.route.firstChild.params.subscribe(
      (params) => (this.invitationId$ = params['id'])
    );
    this.store
      .select(AuthState.HASH)
      .pipe(
        map((hash: string) => {
          if (hash) {
            this.isExternal = true;
          }
        })
      )
      .subscribe();

    this.store
      .select(AuthState.JTW)
      .pipe(
        map((jwt: string) => {
          if (jwt) {
            this.isInternal = true;
          }
        })
      )
      .subscribe();
  }

  ngOnInit() {
    this.loadingService.isLoading(true);
    this.subscription = this.registrationService
      .agentByInvite(this.invitationId$)
      .subscribe((res) => {
        this.isExternal = res.isExternal;
        this.loadingService.isLoading(false);
        this.agent$ = res;
        if (
          !this.isInternal &&
          this.agent$.status !== 'Em preenchimento' &&
          this.agent$.status !== 'Em preenchimento pelo representante' &&
          this.agent$.status !== 'Em preenchimento pelo investidor' &&
          this.agent$.status !== 'Convite enviado' &&
          this.agent$.status !== 'Pendente de preenchimento do investidor' &&
          this.agent$.status !== 'Pendente continuação preenchimento do representante' &&
          this.agent$.status !== 'Em atualização cadastral'
        ) {
          window.location.replace(environment.site);
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
